import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private apiUrl = `${environment.apiUrl}/dashboard`;

  constructor(private http: HttpClient, private auth: Auth) {}

  getStats(range: string = '7d', date?: string): Observable<any> {
    const token = this.auth.getToken();
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    let url = `${this.apiUrl}/stats?range=${range}`;
    if (date) url += `&date=${date}`;
    return this.http.get<any>(url, { headers });
  }
}